import { KeyboardEvent, useCallback } from 'react';

const useEnterKeyNavigation = (containerId?: string) => {
  const handleEnterKey = useCallback(
    (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (e.key !== 'Enter' || e.shiftKey) return;

      e.preventDefault();
      e.stopPropagation();

      const input = e.currentTarget;
      input.blur();

      setTimeout(() => {
        const hasError =
          input.getAttribute('data-error') === 'true' ||
          (input instanceof HTMLInputElement && !input.checkValidity());

        if (hasError) {
          input.focus();
          input.reportValidity?.();

          return;
        }

        const container =
          containerId
            ? document.getElementById(containerId)
            : input.closest('[data-testid="step-component"]') ?? input.parentElement;

        if (!container) return;

        const focusables = Array.from(
          container.querySelectorAll<HTMLElement>(
            'input:not([type="hidden"]):not([disabled]):not([type="checkbox"]), textarea:not([disabled])',
          ),
        ).filter(el => window.getComputedStyle(el).display !== 'none');

        const currentIndex = focusables.indexOf(input);
        const next = focusables[currentIndex + 1];

        if (next) next.focus();
        else input.blur();
      }, 0);
    },
    [containerId],
  );

  return { handleEnterKey };
};

export default useEnterKeyNavigation;
